import React from "react";

  const getYouTubeVideoId = (url) => {
    try {
      const parsedUrl = new URL(url);

      // Standard format
      if (parsedUrl.searchParams.get("v")) {
        return parsedUrl.searchParams.get("v");
      }

      // Shorts format
      if (parsedUrl.pathname.startsWith("/shorts/")) {
        return parsedUrl.pathname.split("/shorts/")[1];
      }

      // youtu.be short link
      if (parsedUrl.hostname === "youtu.be") {
        return parsedUrl.pathname.slice(1);
      }

      return null;
    } catch {
      return null;
    }
  };

const YoutubeRenderer = ({ videoUrl = "" }) => {
  // Extract video ID from the URL
  // const videoId = videoUrl?.split("v=")[1]?.split("&")[0];

  const videoId = getYouTubeVideoId(videoUrl);

  return (
    <div className="w-full h-full flex items-center justify-center">
      {videoId ? (
        <iframe
          className="w-full h-full"
          style={{ borderRadius: "8px" }}
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <p className="text-red-500">Invalid YouTube URL</p>
      )}
    </div>
  );
};

export default YoutubeRenderer;
